import React, { useEffect, useState, useContext } from 'react'
import queryString from 'query-string'
import styled from 'styled-components'

import { addMessageListener, isFullScreen } from '../../../helpers'
import close from '../../../assets/icons/close.svg'
import vars from '../common/vars'
import { ConfigContext } from '../../../ConfigContext'

const LoadBehindPreview = () => {
  const [url, setUrl] = useState()
  const { loadBehindHost, embedded } = useContext(ConfigContext)

  useEffect(() => (
    registerLoadBehindListener(setUrl)
  ), [])

  const showPreview = isFullScreen() || embedded

  if (!url || url === '/' || !showPreview) { return null }

  const processedUrl = addShowHeaderFalse(addHostIfRelative(loadBehindHost, url))

  return (
    <div style={{ height: '50%', position: 'relative' }}>
      <CloseButton onClick={() => setUrl(null)} />
      <iframe
        title="Preview"
        style={{ height: '100%', width: '100%' }}
        frameBorder="0"
        src={processedUrl}
      />
    </div>
  )
}

const registerLoadBehindListener = setUrl => (
  addMessageListener('dbNav', ({ value }) => {
    setUrl(value.dbNav || value)
  })
)

const addHostIfRelative = (host, url) => {
  if (url.includes('.')) { return url }

  return (host || window.location.origin) + url
}

const addShowHeaderFalse = url => {
  const parsed = queryString.parseUrl(url)
  const newQuery = { ...parsed.query, showHeader: 'false' }

  return `${parsed.url}?${queryString.stringify(newQuery)}`
}

const Button = styled.button`
  background: ${vars.grey1};
  border-radius: 50px;
  position: absolute;
  top: 15px;
  right: 15px;
  border: none;
  width: 35px;
  height: 35px;
  cursor: pointer;

  img {
    width: 100%;
    filter: invert(0%) sepia(100%) saturate(2%) hue-rotate(142deg) brightness(96%) contrast(100%);
    height: 23px;
    width: 23px;
  }
`

const CloseButton = ({ onClick }) => (
  <Button onClick={onClick}>
    <img src={close} aria-label='close preview' alt="close preview" />
  </Button>
)

export default LoadBehindPreview



// WEBPACK FOOTER //
// ./src/ChatWidget/components/LoadBehindPreview/index.js